import React, {Suspense} from "react";
import * as ReactDOM from "react-dom";
import ErrorBoundary from "../../utils/ErrorBoundary";

const ProductRelatedLooks = React.lazy(() => import("./ProductRelatedLooks"));

const ProductRelatedLooksPortal = () => {
  const container = document.getElementById("shop-the-look-detail-pdp");
  const itemId = document.body.querySelector<HTMLElement>("#AddToCartButtonRoot")?.dataset.itemid;
  const containerLink = container?.dataset.link || "/shopthelook.html";

  if (!container || !itemId) {
    return null;
  }

  return ReactDOM.createPortal(
    <ErrorBoundary fallback={null} occurrence="ProductRelatedLooks">
      <Suspense fallback={null}>
        <ProductRelatedLooks itemId={itemId} containerLink={containerLink} />
      </Suspense>
    </ErrorBoundary>,
    container,
  );
};

export default ProductRelatedLooksPortal;
